// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-navigation{display:inline-block;border-bottom:.0625rem solid #dadada;margin:2rem 0;padding-bottom:.625rem}.sub-navigation__item{position:relative;display:inline-block;margin-right:1.25rem;padding:0 .125rem}.sub-navigation__item.sub-navigation__item--selected:after{position:absolute;bottom:-0.75rem;left:0;width:100%;height:.25rem;background:#632bdc;content:\"\"}.sub-navigation__item:last-child{margin-right:0}.sub-navigation__link{font-size:1rem}", ""]);
// Exports
module.exports = exports;
